import DimensionInput from './DimensionInput.js'

/**
 * All three dimensions as inputs
 *
 * @param {Object} props
 * @param {String} props.id
 * @param {Number|String} props.length
 * @param {Number|String} props.width
 * @param {Number|String} props.height
 * @param {Boolean} [props.autoFocus]
 * @param {Boolean} [props.disabled]
 * @param {String} [props.errorMessage]
 * @param {Boolean} props.hasLengthError
 * @param {Boolean} props.hasWidthError
 * @param {Boolean} props.hasHeightError
 * @param {String} [props.warningMessage]
 * @param {Function} props.setLength
 * @param {Function} props.setWidth
 * @param {Function} props.setHeight
 * @param {Function} [props.onEnterKeyPress]
 * @returns {React.ReactNode}
 */
export default function DimensionsInput({
  id,
  length,
  setLength,
  hasLengthError,
  width,
  setWidth,
  hasWidthError,
  height,
  setHeight,
  hasHeightError,
  errorMessage,
  warningMessage,
  autoFocus,
  disabled,
  onEnterKeyPress,
  widthPerCharacter,
}) {
  id = id || 'dimensions_length'
  // Don't default to showing invalid error in BulkDimensions
  const hasAllDimensions = !!length && !!width && !!height

  return (
    <div>
      <div className="flex flex-wrap">
        <DimensionInput
          id={id}
          label="x"
          value={length}
          onChange={setLength}
          hasError={hasLengthError}
          autoFocus={autoFocus}
          disabled={disabled}
          onEnterKeyPress={onEnterKeyPress}
          widthPerCharacter={widthPerCharacter}
        />
        <DimensionInput
          label="x"
          value={width}
          onChange={setWidth}
          hasError={hasWidthError}
          disabled={disabled}
          onEnterKeyPress={onEnterKeyPress}
          widthPerCharacter={widthPerCharacter}
        />
        <DimensionInput
          label="in"
          value={height}
          onChange={setHeight}
          hasError={hasHeightError}
          disabled={disabled}
          onEnterKeyPress={onEnterKeyPress}
          widthPerCharacter={widthPerCharacter}
        />
      </div>
      {hasAllDimensions && errorMessage && !disabled && (
        <pre className="wrap--error-wb lh-sm">
          <small className="error margin-top-0">{errorMessage}</small>
        </pre>
      )}
      {hasAllDimensions && !errorMessage && warningMessage && !disabled && (
        <pre className="wrap--error-wb lh-sm">
          <small className="warning margin-top-0">{warningMessage}</small>
        </pre>
      )}
    </div>
  )
}
